import Box from "@mui/material/Box";
import { FormProvider, useForm } from "react-hook-form";
import RhfTextBox from "../../../libs/rhf-mui/RhfTextBox";
import {
  AppBar,
  Button,
  Container,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import {
  linear_content_style,
  linear_item,
  linear_v,
} from "../../../libs/linear-layout/LinearLayout";
import {
  AppContextProps,
  useAppContext,
} from "../../../libs/app-core/AppContext";
import { UniAnswerDAO } from "../../dao/UniAnswerDAO";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import { useSearchParams } from "react-router-dom";
import { ROUTE_spwk_quest } from "../../Routes";
import { FrmSpwkQuestProps } from "../FrmSpwkQuestionnaire";
import { useGV } from "../../GV";
import AuthHelper from "../../heplers/AuthHelper";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import { useEffect, useState } from "react";
import {
  ProjectDAO,
  project_data as WSProjectData,
} from "../../dao/ProjectDAO";
import Label from "../../../libs/rhf-mui/ui/Label";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import MemberNavbar from "../../components/MemberNavbar";

type Props = {};
const FrmMemberLogin = (props: Props) => {
  const [searchParams] = useSearchParams(); // UrlQueryParams
  const { t } = useTranslation();
  // customer_id 公司編號 (目前市場次編號，未來可能改變)
  let cid: string | null = searchParams.get("cid");
  if (cid == null || cid === "") {
    console.log("缺少 cid !!!");
    throw new Error("缺少 cid !!!");
  }

  const [project_data, set_project_data] = useState<WSProjectData | null>(null);
  const currentTime = new Date();
  useEffect(() => {
    async_func1();
  }, [cid]);
  async function async_func1() {
    try {
      let project_data = await ProjectDAO.Public_FetchCustInfoByCid(cid);
      if (project_data == null) {
        throw new_ErrorAlert(`不應該沒資料 !!!`);
      } else if (project_data != null) {
        set_project_data(project_data);
      } else {
        throw new_ErrorAlert("未預期的錯誤");
      }
    } catch (ex: any) {
      MessageDialog.Show(ctx, ex.message, "ApiError!", {
        colorMeaning: "Danger",
      });
      ctx.NavigateToErrorPage("", "loginpage", ex.message);
    }
  }

  const rhf = useForm<any>();
  const ctx = useAppContext();
  const GV = useGV();

  async function OnSubmit(rhf_data: any) {
    const username = rhf_data["帳號"];
    const password = rhf_data["密碼"];
    AuthHelper.MemberLogin(GV, ctx, cid, username, password);
  }

  function OnInvalid(errors: any) {
    alert(errors);
  }

  if (cid == null || cid === "") {
    return <></>;
  }

  if (project_data === null) {
    return <></>;
  }

  return (
    <Box style={linear_content_style}>
      <Grid {...linear_v}>
        <Grid {...linear_item} flex={1}>
          <Box
            style={linear_content_style}
            sx={{ backgroundColor: { xs: "#ffffff", sm: "#eff0f4" } }}
          >
            <FormProvider {...rhf}>
              <Grid {...linear_item}>{render_header()}</Grid>
              <Container maxWidth="lg" sx={{ mx: "auto" }}>
                <form
                  onSubmit={rhf.handleSubmit(
                    (data: any) => {
                      OnSubmit(data);
                    },
                    (errors: any) => {
                      OnInvalid(errors);
                    }
                  )}
                >
                  <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ mt: 2 }}
                  >
                    {Is開放時間(project_data)
                      ? render_Login(project_data)
                      : render_開放時間(project_data)}
                  </Grid>
                </form>
              </Container>
            </FormProvider>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );

  function render_Login(project_data: WSProjectData) {
    let textSize = "inherit"; //公司名稱多寡, 調整字體大小
    if (project_data.cust_name.length <= 9) {
      //pass
    } else if (
      project_data.cust_name.length >= 10 &&
      project_data.cust_name.length <= 12
    ) {
      textSize = "16px";
    } else if (project_data.cust_name.length >= 13) {
      textSize = "14px";
    }

    const inputStyle = {
      fontSize: textSize,
    };

    return (
      <>
        <Grid item sx={{ mb: 3 }}>
          <TextField
            name="公司名稱"
            label={t("公司名稱")}
            variant="filled"
            value={project_data.cust_name}
            disabled
            InputProps={{
              readOnly: true,
              style: inputStyle,
            }}
            sx={{ minWidth: "250px" }}
          />
        </Grid>
        <Grid item sx={{ mb: 3 }}>
          <RhfTextBox
            type="text"
            name="帳號"
            label={t("帳號") + getIdPwInfo(project_data.account_rule)}
            InputLabelProps={{ shrink: true }}
            variant="filled"
          />
        </Grid>
        <Grid item sx={{ mb: 3 }}>
          <RhfTextBox
            type="password"
            name="密碼"
            label={t("密碼") + getIdPwInfo(project_data.password_rule)}
            InputLabelProps={{ shrink: true }}
            variant="filled"
          />
        </Grid>
        <Grid item>
          <Button type="submit" variant="contained">
            {t("登入")}
          </Button>
        </Grid>
        <Grid item></Grid>
      </>
    );
  }

  function render_開放時間(project_data: WSProjectData) {
    if (
      dayjs(project_data.quest_start).year() === 2999 ||
      dayjs(project_data.quest_end).year() === 1800
    ) {
      return (
        <Grid item>
          <Label>{t("問卷未開放")}</Label>
          <br />
        </Grid>
      );
    } else {
      return (
        <Grid item>
          <Label>
            {t("問卷可於以下時段進行填答: ") +
              dayjs(project_data.quest_start).format("YYYY/MM/DD HH:mm") +
              " ~ " +
              dayjs(project_data.quest_end).format("YYYY/MM/DD HH:mm")}
          </Label>
          <br />
          <Label>
            {t("現在時間為: ") + dayjs(currentTime).format("YYYY/MM/DD HH:mm")}
          </Label>
          <br />
          <br />
        </Grid>
      );
    }
  }

  function getIdPwInfo(rule: string) {
    if (rule === "") {
      // pass;
    } else if (rule === "生日") {
      return t(" (生日, 民國年:YYMMDD)");
    } else if (rule === "身分證") {
      return t(" (身份證)");
    } else if (rule === "員工編號") {
      return t(" (員工編號)");
    } else if (rule === "姓名") {
      return t(" (姓名)");
    } else {
      throw new_ErrorAlert(`4792468 ${t("未知的錯誤")}`);
    }
  }

  function render_header() {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <Typography
              variant="subtitle2"
              component="div"
              sx={{ flexGrow: 1 }}
            >
              {t("健檢問卷系統")}
            </Typography>

            <MemberNavbar />
          </Toolbar>
        </AppBar>
      </Box>
    );
  }
};

export default FrmMemberLogin;

/** 問卷可填寫時間 (目前依照場次定義) */

export async function NavigateToFirstPage_Asnyc(
  ctx: AppContextProps,
  member_guid: string
) {
  await OpenPageFrmSpwkQuest_HoChen_Async(member_guid, "ALL", "ALL", ctx);
}

export async function OpenPageFrmSpwkQuest_HoChen_Async(
  member_guid: string,
  pill_text: string,
  uni_func_guid: string,
  ctx: AppContextProps
) {
  let answer_list = await UniAnswerDAO.WS_Select_ByMemberGuid(member_guid);

  // 只篩選特作
  answer_list = answer_list.filter(
    (x) => x.base_form_guid != null && x.base_form_guid !== ""
  );

  if (answer_list.length === 1) {
    let params: FrmSpwkQuestProps = {
      answer_guid: answer_list[0].guid,
      func_guid: pill_text === "ALL" ? undefined : uni_func_guid,
    };

    ctx.Navigate(ROUTE_spwk_quest.url, { state: params });
  } else if (answer_list.length === 0) {
    MessageDialog.Show(ctx, "尚未設定 Answer !");
  } else {
    MessageDialog.Show(ctx, "多於一個 Answer !?");
  }
}

function Is開放時間(project: WSProjectData) {
  const now = dayjs();
  const start = dayjs(project.quest_start);
  const end = dayjs(project.quest_end);
  if (now.isAfter(start) && now.isBefore(end)) {
    return true;
  } else {
    return false;
  }
}
